import React, { useState } from 'react';
import { Redirect, Route, withRouter } from 'react-router';
import { CampfireSwitch } from '../../../content-blocks/common/CampfireSwitch';
import { WaitlistVolunteersScreen } from './waitlist-volunteers/WaitlistVolunteersScreen';
import { VolunteersApplicationsScreen } from './volunteers-applications/VolunteersApplicationsScreen';
import { VolunteersRoleApplicationsScreen } from './volunteers-role-applications/VolunteersRoleApplicationsScreen';
import { ImportingVolunteersScreen } from './volunteers-importing/ImportingVolunteersScreen';
import { DeactivateVolunteersScreen } from '../../admin/volunteers-deactivate/DeactivateVolunteersScreen';
import { VolunteersProvider } from './VolunteersContext';
import { VolunteersTabsWrapper, useVisibleVolunteersTabs } from './VolunteersTabsWrapper';
import { Page } from '../../../global/components';
import { VolunteersTutorialDialog } from './VolunteersTutorialDialog';
import VolunteerDatabaseScreen from './volunteer-database/SimpleVolunteerDatabaseScreen';
import IncomingVolunteersScreenSimple from './incoming-volunteers/IncomingVolunteersScreenSimple';

export const VolunteersScreen = withRouter(({ match }) => {
  const [tutorialDialogOpen, setTutorialDialogOpen] = useState<boolean>(false);
  const visibleTabPaths = useVisibleVolunteersTabs().map((tab) => tab.value);
  const defaultPath = visibleTabPaths[0] ?? `${match.path}/volunteers-database`;
  const renderTab = (path: string, screen: React.ReactNode) => () =>
    visibleTabPaths.length > 0 && !visibleTabPaths.includes(path) ? (
      <Redirect to={defaultPath} />
    ) : (
      <VolunteersProvider>
        <VolunteersTabsWrapper>{screen}</VolunteersTabsWrapper>
      </VolunteersProvider>
    );

  return (
    <Page
      pageHelpOptions={{
        onClick: () => setTutorialDialogOpen(true),
      }}
    >
      <CampfireSwitch>
        <Route exact path={match.path} render={() => <Redirect to={defaultPath} />} />
        <Route
          exact
          path={`${match.path}/volunteers-database`}
          render={renderTab(`${match.path}/volunteers-database`, <VolunteerDatabaseScreen />)}
        />
        <Route
          exact
          path={`${match.path}/incoming-volunteers`}
          render={renderTab(`${match.path}/incoming-volunteers`, <IncomingVolunteersScreenSimple />)}
        />
        <Route
          exact
          path={`${match.path}/waitlist-volunteers`}
          render={renderTab(`${match.path}/waitlist-volunteers`, <WaitlistVolunteersScreen />)}
        />
        <Route
          exact
          path={`${match.path}/volunteers-applications`}
          render={renderTab(`${match.path}/volunteers-applications`, <VolunteersApplicationsScreen />)}
        />
        <Route
          exact
          path={`${match.path}/volunteers-role-applications`}
          render={renderTab(`${match.path}/volunteers-role-applications`, <VolunteersRoleApplicationsScreen />)}
        />
        <Route
          exact
          path={`${match.path}/volunteers-importing`}
          render={renderTab(`${match.path}/volunteers-importing`, <ImportingVolunteersScreen />)}
        />
        <Route
          exact
          path={`${match.path}/volunteers-deactivate`}
          render={() => (
            <VolunteersProvider>
              <VolunteersTabsWrapper>
                <DeactivateVolunteersScreen />
              </VolunteersTabsWrapper>
            </VolunteersProvider>
          )}
        />
      </CampfireSwitch>
      <VolunteersTutorialDialog
        open={tutorialDialogOpen}
        onClose={() => {
          setTutorialDialogOpen(false);
        }}
      />
    </Page>
  );
});
